<template>
  <div class="flex flex-col gap-4 max-w-md">
    <div class="flex items-center gap-3">
      <label class="text-base font-medium text-gray-700">{{ title }}</label>
      <el-button type="primary" circle size="small" @click="addItem" class="!w-7 !h-7">
        <el-icon><Plus /></el-icon>
      </el-button>
    </div>

    <div class="flex flex-col gap-3">
      <div v-for="(_, index) in val" :key="index" class="flex items-center gap-2">
        <el-input
          v-model="val[index]"
          @input="changed = true"
          maxlength="255"
          class="flex-1"
        />
        <el-button
          type="danger"
          text
          @click="removeItem(index)"
          class="!text-red-500 hover:!text-red-600 !p-1"
        >
          <el-icon size="18"><Close /></el-icon>
        </el-button>
      </div>
    </div>

    <el-button v-if="changed" :loading="saving" @click="update" class="self-start mt-2">
      {{ $t('update') }}
    </el-button>
  </div>
</template>

<script setup lang="ts">
import {ref, watch} from 'vue'
import {Plus, Close} from '@element-plus/icons-vue'

const props = defineProps<{
  title: string
  modelValue: string[]
  saving?: boolean
}>()

const emit = defineEmits<{
  (e: 'update', value: string[]): void
}>()

const val = ref<string[]>([...props.modelValue])
const changed = ref(false)

watch(
  () => props.modelValue,
  (next) => {
    if (!changed.value) {
      val.value = [...next]
    }
  }
)

function addItem() {
  val.value.push('')
  changed.value = true
}

function removeItem(index: number) {
  val.value.splice(index, 1)
  changed.value = true
}

function update() {
  changed.value = false
  emit('update', val.value.map((v) => v.trim()).filter((v) => v !== ''))
}
</script>
